// src/locales/en/phoneBlacklist.js
export const phoneBlacklist = {
  pageTitle: 'Phone Blacklist',
  pageDescription: 'Manage blacklisted phone numbers to flag customers with fake or fraudulent orders',
  addEntry: 'Add Phone Number',
  editEntry: 'Edit Entry',
  searchPlaceholder: 'Search by phone number...',
  exportCsv: 'Export CSV',
  noRecords: 'No blacklisted phone numbers',
  noRecordsDescription: 'Add phone numbers belonging to customers who place fake or fraudulent orders',

  // Table columns
  colPhoneNumber: 'Phone Number',
  colReason: 'Reason',
  colAddedBy: 'Added By',
  colAddedAt: 'Added At',
  colActions: 'Actions',

  // Modal
  phoneNumber: 'Phone Number',
  phoneNumberPlaceholder: 'e.g. 0771234567',
  phoneNumberRequired: 'Phone number is required',
  reason: 'Reason',
  reasonPlaceholder: 'Why is this number blacklisted? (optional)',

  // Actions
  save: 'Save',
  cancel: 'Cancel',
  edit: 'Edit',
  delete: 'Delete',
  confirmDelete: 'Remove from Blacklist',
  confirmDeleteMessage: 'Are you sure you want to remove {{phoneNumber}} from the blacklist?',

  // Success messages
  addedSuccess: 'Phone number added to blacklist',
  updatedSuccess: 'Blacklist entry updated',
  deletedSuccess: 'Phone number removed from blacklist',

  // Order form blacklist warning
  blacklistedWarning: 'This number is blacklisted',
  blacklistedWarningWithReason: 'Blacklisted: {{reason}}',

  // Error messages
  loadError: 'Failed to load blacklist',
  addError: 'Failed to add phone number',
  updateError: 'Failed to update entry',
  deleteError: 'Failed to remove phone number',
};
